module.exports = __webpack_public_path__ + "img/roles.f4103fbb.svg";